<template>
  <div id="app">
    <header class="head">
      <a class="back tl" href="javascript:history.back(-1)">
        <i class="el-icon-arrow-left"></i>
      </a>
      <a href="javascript:;" class="font-size: 18px;text-align: center;">
        <small class="font_18 co_f">监督抽查信息</small>
      </a>
    </header>
    <main>
      <div class="notedetail">
        <br>
        <el-form label-position="right" label-width="80px">
          <el-form-item label="产品名称" prop="procedureName">
            <el-input v-model="this.Detail.procedureName" autocomplete="off" disabled></el-input>
          </el-form-item>
          <el-form-item label="品牌名称" prop="brandName">
            <el-input v-model="this.Detail.brandName" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="生产日期" prop="procedureDate">
            <el-input v-model="this.Detail.procedureDate" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="受检单位" prop="subjectUnit">
            <el-input v-model="this.Detail.subjectUnit" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="标示生产企业" prop="manufacturingEnterprise">
            <el-input v-model="this.Detail.manufacturingEnterprise" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="检验报告编号" prop="reportCode">
            <el-input v-model="this.Detail.reportCode" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="检验结论" prop="inspectionConclusion">
            <el-input v-model="this.Detail.inspectionConclusion" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="主要不合格项" prop="mainUnqualifiedItem">
            <el-input v-model="this.Detail.mainUnqualifiedItem" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="抽查日期" prop="checkDate">
            <el-input v-model="this.Detail.checkDate" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="承检机构" prop="checkMechanism">
            <el-input v-model="this.Detail.checkMechanism" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="是否申请复检" prop="isApplyExamination">
            <el-input v-model="this.Detail.isApplyExamination" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="复检结论" prop="recheckConclusion">
            <el-input v-model="this.Detail.recheckConclusion" autocomplete="off" disabled></el-input>
          </el-form-item>
           <el-form-item label="查处结果" prop="investigatetheResultsStr">
            <el-input v-model="this.Detail.investigatetheResultsStr" autocomplete="off" disabled></el-input>
          </el-form-item>

       
        </el-form>
      </div>
    </main>
  </div>
</template>

<script type="text/ecmascript-6">
  import {
    SubjectCreditExtractCheck
  } from '../../api/api';
   var moment = require("moment");
  export default {
    data() {
      return {
      
        Detail: {},
        PageSize: 10,
        CriteriaList: []
      };
    },
    methods: {
      goback() {
        window.history.back()
      },
      getData() {

        this.CriteriaList[0] = {
          Name: "enterprise.unid",
          Value: "%" + JSON.parse(
            sessionStorage.getItem("WapEnterpriseUnid")
          ).unid + "%",
          Operate: "Like",
          DataType: null,
          EndSuffix: "",
          Suffix: null
        };
        this.CriteriaList[1] = {
          Name: "unid",
          Value: "%" + this.$route.query.unid + "%",
          Operate: "Like",
          DataType: null,
          EndSuffix: "",
          Suffix: null
        };
        let varQueryData = {
          pageSize: this.PageSize,
          currentPage: 1,
          query: {
            criteriaList: this.CriteriaList,
          }
        };
        let options = {
          params: {
            queryData: JSON.stringify(varQueryData),
          }
        };
        //调取接口
        SubjectCreditExtractCheck(options).then((res) => {
          if (res.success === true) {
            this.Detail = res.data.data[0]
            this.Detail.checkDate=moment(this.Detail.checkDate).format("YYYY-MM-DD ")
            this.Detail.procedureDate=moment(this.Detail.procedureDate).format("YYYY-MM-DD ")
          }
        })
      },
    },
    //页面加载时候
    created() {
      this.getData()

    }

  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
  .notedetail {
    padding: 0px 10px;

    .article-title {
      h2 {
        color: #333
      }
    }

    span {
      color: #999;

      i {
        vertical-align: text-bottom;
        margin-right: 5px;
      }
    }

    article {
      margin-top: 10px;
      text-indent: 2rem;
      line-height: 1.5rem;
      font-size: 1rem;
    }
  }

</style>



// WEBPACK FOOTER //
// ExtractCheck.vue?849bac26